import { Box, CircularProgress, Stack, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useInterval } from "usehooks-ts";

const ITEM_HEIGHT = 28;

const Item = ({ text }: { text: string }) => (
  <Typography
    className="itemMessage"
    variant="bodyBold"
    style={{
      margin: 0,
      display: "block",
      position: "absolute",
      height: `${ITEM_HEIGHT}px`,
      whiteSpace: "nowrap",
      opacity: 0,
      top: `${ITEM_HEIGHT}px`,
      transition: "top 500ms ease, opacity 500ms ease",
    }}
  >
    {text}
  </Typography>
);

type HSpinnerProps = {
  messages?: string[];
};

export const HSpinner = ({ messages }: HSpinnerProps) => {
  const t = useIntl();
  const [cycleCount, setCycleCount] = useState(0);

  const showNextMessage = useCallback(() => {
    const allMessages = document.querySelectorAll(".itemMessage");
    if (allMessages.length === 0) return;
    allMessages.forEach((_, index) => {
      const message = document.querySelector(
        `.itemMessage:nth-of-type(${index + 1})`,
      ) as HTMLElement;
      if (message) {
        message.style.top = `${ITEM_HEIGHT}px`;
        message.style.opacity = "0";
      }
    });
    const msgToShow = document.querySelector(
      `.itemMessage:nth-of-type(${cycleCount + 1})`,
    ) as HTMLElement;
    if (msgToShow) {
      msgToShow.style.top = `0px`;
      msgToShow.style.opacity = "1";
    }
  }, [cycleCount]);

  useInterval(() => {
    showNextMessage();
    const messagesList = document.querySelectorAll(".itemMessage");
    setCycleCount(cycleCount >= messagesList.length - 1 ? 0 : cycleCount + 1);
  }, 3000);

  useEffect(() => {
    showNextMessage();
  }, [showNextMessage]);

  const defaultMessages = [
    t.formatMessage({ id: "spinner.default" }),
    t.formatMessage({ id: "spinner.delayed" }),
  ];

  return (
    <Stack
      flex="1"
      justifyContent="center"
      alignItems="center"
      position="relative"
    >
      <CircularProgress
        role="progressbar"
        aria-label="Caricamento in corso..."
        size={68}
        sx={theme => ({
          color: theme.palette.primary.main,
        })}
      />
      <Box
        id="slider"
        sx={{
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          top: "20px",
          height: ITEM_HEIGHT,
          overflow: "hidden",
        }}
      >
        {(messages || defaultMessages)?.map((message, index) => (
          <Item key={index} text={message} />
        ))}
      </Box>
    </Stack>
  );
};
